// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"Testimonials_testimonials__1Hgg6","testimonial":"Testimonials_testimonial__3QqYP","description":"Testimonials_description__3015d"};